import { render, staticRenderFns } from "./FileLookup.vue?vue&type=template&id=33ce9c52&scoped=true"
import script from "./FileLookup.vue?vue&type=script&lang=js"
export * from "./FileLookup.vue?vue&type=script&lang=js"
import style0 from "./FileLookup.vue?vue&type=style&index=0&id=33ce9c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ce9c52",
  null
  
)

export default component.exports